<!-- 人员管理弹窗 -->
<!-- 更新角色中的人员 -->
<template>
	<el-dialog :title="`人员管理(${roleName})`" :modal-append-to-body="false" :visible.sync="visible" :close-on-click-modal="false" width="650px" :before-close="closeDialog">
        <el-transfer
        	class="transfer"
            :titles="['可选用户','角色内']"
            filterable
            :filter-method="filterMethod"
            :props="{key:'userId',label: 'nickname'}"
            v-model="userListSelected"
            :data="userList">
        </el-transfer>
        <div class="btn_box">
            <el-button @click="closeDialog">取 消</el-button>
            <el-button type="primary" @click="getUpdateUserList">确 定</el-button>
        </div>
	</el-dialog>
</template>

<script>
export default {
	name: "updateRole",
	data(){
		return {
			visible: false,
			userList: [],
			userListSelected: [],
			roleId: "",
			roleName: "",
		}
	},
	methods: {
		open(roleData){
			this.roleId = roleData.roleId;
			this.roleName = roleData.roleName;
			this.getRoleUserList()
			this.visible = true;
		},
		filterMethod(query, item) {
          return item.nickname.indexOf(query) > -1;
        },
		// 人员管理列表
        getRoleUserList() {
            this.$api.getRoleUserRoleList({
                roleId: this.roleId
            }).then(res => {
            	if(res.errcode != 0) return false;
                this.userList = res.data.userList
                this.userListSelected = res.data.userListSelected
            })
        },
        // 确定更新
        getUpdateUserList() {
            this.$api.getRoleUpdateUserList({
                roleId: this.roleId,
                userList: this.userListSelected
            }).then(res => {
            	if(res.errcode != 0) return false;
                this.closeDialog();
                this.$message.success(res.errmsg)
            })
        },
		closeDialog() {
			this.visible = false;
			this.userList = [];
			this.userListSelected = [];
			this.roleId = "";
		}
	}
}
</script>

<style lang="scss" scoped>
.btn_box{
	margin-top: 20px;
	text-align: center;
}
</style>